// Components
export { default as Footer } from './components/Footer';

// Images
export {
  default as menuLogo
} from './assets/images/Vape-Free-Reverse-Text-Red-X Copy@2x.jpg';
export { default as globalRibbon } from './assets/images/global-ribbon.svg';
export {
  default as confidenceRating
} from './assets/images/confidence-rating.svg';
export {
  default as stronglyAgree
} from './assets/images/confidence-strongly-agree.svg';
export { default as agree } from './assets/images/confidence-agree.svg';
export { default as neutral } from './assets/images/confidence-neutral.svg';
export { default as disagree } from './assets/images/confidence-disagree.svg';
export {
  default as stronglyDisagree
} from './assets/images/confidence-strongly-disagree.svg';



//////////////////
// WEBPACK FOOTER
// ../shared/src/index.js
// module id = 505
// module chunks = 0